import VueBusiness from "@/business/VueBusiness";

export default  {

  getUtilizarConfigsFunrejus(cod){
    return VueBusiness.getVueRoot().isEstadoPR && ['T_512', 'T_513', 'T_514', 'T_515', 'T_518', 'T_519', 'T_520', 'T_522', 'T_523', 'T_524', 'T_525', 'T_527', 'T_531', 'T_547'].includes(cod);
  },

  getCodigoTribunalArquivamento(cod){
    return VueBusiness.getVueRoot().isEstadoPR && ['T_532'].includes(cod);
  },

  getCodigoTribunalApostilamento(cod){
    return VueBusiness.getVueRoot().isEstadoPR && ['T_534'].includes(cod);
  },

  getCodigoTribunalConciliacaoMediacao(cod){
    return VueBusiness.getVueRoot().isEstadoPR && ['T_542'].includes(cod);
  },

  getCodigoTribunalPesquisaBens(cod){
    return VueBusiness.getVueRoot().isEstadoPR && ['T_541'].includes(cod);
  },

  getCodigoTribunalCedulas(cod){
    return VueBusiness.getVueRoot().isEstadoPR && ['T_518'].includes(cod);
  },

  getCodigoTribunalCertidao(cod){
    return VueBusiness.getVueRoot().isEstadoPR && ['T_546'].includes(cod);
  },
}
